export interface SearchIndexItem {
  title: string;
  path: string;
  section: string;
  content: string;
}

export const searchIndex: SearchIndexItem[] = [
  {
    title: "Getting Started",
    path: "/",
    section: "Getting Started",
    content: "Welcome to Ana Security! This guide will help you get up and running with comprehensive security scanning in just a few minutes. Learn how to log in, explore your dashboard, run your first security scan, and fix vulnerabilities automatically with ANA Actions."
  },
  {
    title: "Quick Start",
    path: "/quickstart",
    section: "Getting Started",
    content: "Quick start guide for Ana Security. Set up your first project, run security scans, and start fixing vulnerabilities in minutes. Perfect for developers who want to get started immediately."
  },
  {
    title: "Security Features",
    path: "/features",
    section: "Features & Integration",
    content: "Explore Ana Security's comprehensive security scanning capabilities including SCA, SAST, DAST, Secrets Detection, Threat Modeling, SBOM, API Security, and Infrastructure Scanning. Built-in security measures ensure safe operations."
  },
  {
    title: "Dashboard Overview",
    path: "/dashboard",
    section: "Features & Integration",
    content: "Your security dashboard is your command center showing security metrics, scan results, and vulnerability status. Understand your security posture with real-time metrics and actionable insights."
  },
  {
    title: "Projects Management",
    path: "/projects",
    section: "Features & Integration",
    content: "Organize and manage your security projects. View project cards, track scan history, and manage repository connections for comprehensive security coverage."
  },
  {
    title: "SCA - Software Composition Analysis",
    path: "/sca",
    section: "Security Modules",
    content: "Scan your dependencies for known vulnerabilities. SCA identifies security issues in third-party libraries and provides automated fixes through ANA Actions."
  },
  {
    title: "SAST - Static Application Security Testing",
    path: "/sast",
    section: "Security Modules",
    content: "Analyze your source code for security vulnerabilities. SAST scanning identifies potential security issues in your codebase before deployment."
  },
  {
    title: "DAST - Dynamic Application Security Testing",
    path: "/dast",
    section: "Security Modules",
    content: "Test your running applications for security vulnerabilities. DAST scanning identifies runtime security issues and configuration problems."
  },
  {
    title: "Secrets Detection",
    path: "/secrets",
    section: "Security Modules",
    content: "Prevent credential leaks and exposed secrets. Automatically detect API keys, passwords, and other sensitive information in your codebase."
  },
  {
    title: "Threat Modeling",
    path: "/threat-modeling",
    section: "Security Modules",
    content: "Identify and analyze potential security threats. Systematic approach to understanding attack vectors and security risks in your applications."
  },
  {
    title: "SBOM - Software Bill of Materials",
    path: "/sbom",
    section: "Security Modules",
    content: "Track all software components and dependencies. Generate comprehensive software bill of materials for compliance and security tracking."
  },
  {
    title: "API Security",
    path: "/api-security",
    section: "Security Modules",
    content: "Secure your API endpoints and interfaces. Comprehensive API security testing and vulnerability assessment for REST and GraphQL APIs."
  },
  {
    title: "Infrastructure Security",
    path: "/infrastructure",
    section: "Security Modules",
    content: "Secure your deployment and infrastructure. Scan cloud configurations, container images, and infrastructure as code for security issues."
  },
  {
    title: "ANA Actions",
    path: "/ana-actions",
    section: "Automation",
    content: "Automated security fixes and remediation. ANA Actions automatically creates pull requests to fix security vulnerabilities in your dependencies and code."
  },
  {
    title: "Integrations",
    path: "/integrations",
    section: "Features & Integration",
    content: "Connect GitHub, Bitbucket, and other development tools. Set up CI/CD integration for automated security scanning and seamless workflow integration."
  },
  {
    title: "User Guide",
    path: "/user-guide",
    section: "Learning",
    content: "Comprehensive user guide for Ana Security. Detailed instructions for all features, best practices, and advanced configuration options."
  }
];
